import apiService from './api.service';
/**
 * Get travel requirements
 */
async function getTravelRequirements(body) {
  const requirements = await apiService.client('/travel/doc/', {
    method: 'POST',
    body,
    live: true,
  });
  return requirements;
}

export default { getTravelRequirements };
